__webpack_require__.p = "https://actio-labs.github.io/hexa-protocol-lot/";